export default function HeroSection() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-[64px] md:pt-[72px] min-h-screen flex items-center">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              🔥 今日热榜更新中
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              黑料每日大赛
              <br />
              <span className="text-primary-600">全网吃瓜第一站</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              每天更新最新爆料，一站吃遍全网瓜
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-8">
              黑料每日大赛每日更新最新爆料，汇聚全网今日黑料、吃瓜事件与最新黑料合集。无论是娱乐圈风云、网红翻车现场，还是社会热点扒皮，我们都以最快速度为你速递。这里是全网最活跃的吃瓜社区，每日更新从不间断，黑料每日速递让你不错过任何一口好瓜。今日黑料爆料已上线，快来看看今天又有哪些精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-600">1,280+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">今日更新爆料</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-600">86,500+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">累计吃瓜合集</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-600">32.6万</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">吃瓜群众在线</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleNavClick('#ranking'); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleNavClick('#topics'); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-800 rounded-full font-medium text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer no-underline border border-background-200/70"
              >
                <i className="ri-hashtag"></i>
                查看话题热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20crimson%20and%20amber%20tones%2C%20dynamic%20geometric%20shapes%20overlapping%20on%20dark%20background%2C%20sense%20of%20excitement%20and%20breaking%20news%2C%20editorial%20design%20aesthetic%2C%20bold%20contrast%2C%20modern%20magazine%20cover%20style%2C%20eye-catching%20visual%20with%20vibrant%20energy%2C%20no%20text&width=800&height=600&seq=hero-main-visual-01&orientation=landscape"
                alt="黑料每日大赛 - 全网吃瓜第一站主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}